module.exports = {
  en: {
    'HRES35UC1': {
      '0': '[HRES35U] Transfer Request',
      '10': '[HRES35U] Transfer Request',
      '20': 'No.',
      '30': 'Emp. Code',
      '40': 'Name',
      '50': 'Req. Date',
      '60': 'Date Move',
      '70': 'Status',
      '80': 'Code Appr.',
      '90': 'Appr. Date',
      '100': 'Remark',
      '110': 'Next Approve',
      '120': 'Req. No.'
    },
    'HRES35UC2': {
      '0': 'Approve Detail',
      '10': 'For Employee Code :',
      '20': 'Approved Level :',
      '30': 'Approved By :',
      '40': 'Date :',
      '50': 'Effective date :',
      '60': 'Type of Movement :',
      '70': 'Current Status :',
      '80': 'Status :',
      '90': 'Approved',
      '100': 'Refused',
      '110': 'Remark :'
    },
    'HRES35UC3': {
      '0': 'Detail of Transfer Request',
      '10': 'Detail of Transfer Request',
      '20': 'Current Data',
      '30': 'New Data',
      '40': 'Department',
      '50': 'Position',
      '60': 'Job Description',
      '70': 'Work Location',
      '80': 'Remarks'
    },
    'HRES35UC4': {
      '0': 'List of Type of Movement',
      '10': 'Type of Movement',
      '20': 'Type of Movement',
      '30': 'Description',
      '40': 'Page'
    }
  },
  th: {
    'HRES35UC1': {
      '0': '[HRES35U] อนุมัติการขอโอนย้าย',
      '10': '[HRES35U] อนุมัติการขอโอนย้าย',
      '20': 'ลำดับที่',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ',
      '50': 'วันที่ยื่นคำร้อง',
      '60': 'วันที่ขอย้าย',
      '70': 'สถานะ',
      '80': 'ผู้อนุมัติ',
      '90': 'วันที่อนุมัติ',
      '100': 'หมายเหตุการอนุมัติ',
      '110': 'ผู้อนุมัติลำดับถัดไป',
      '120': 'ลำดับคำร้อง'
    },
    'HRES35UC2': {
      '0': 'รายละเอียดการอนุมัติ',
      '10': 'สำหรับพนักงาน :',
      '20': 'ลำดับที่อนุมัติ :',
      '30': 'รหัสผู้อนุมัติ :',
      '40': 'วันที่ :',
      '50': 'วันที่มีผลบังคับใช้ :',
      '60': 'ประเภทเคลื่อนไหว :',
      '70': 'สถานะปัจจุบัน :',
      '80': 'สถานะ :',
      '90': 'อนุมัติ',
      '100': 'ไม่อนุมัติ',
      '110': 'หมายเหตุ :'
    },
    'HRES35UC3': {
      '0': 'รายละเอียดการขอโอนย้าย',
      '10': 'รายละเอียดการขอโอนย้าย',
      '20': 'ข้อมูลปัจจุบัน',
      '30': 'ข้อมูลใหม่',
      '40': 'หน่วยงาน',
      '50': 'ตำแหน่ง',
      '60': 'ลักษณะงาน',
      '70': 'สถานที่ทำงาน',
      '80': 'หมายเหตุ'
    },
    'HRES35UC4': {
      '0': 'ประเภทการเคลื่อนไหว',
      '10': 'ประเภทการเคลื่อนไหว',
      '20': 'ประเภทการเคลื่อนไหว',
      '30': 'รายละเอียด',
      '40': 'หน้า'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres35u.js